module.exports = __webpack_public_path__ + "src/assets/img/wmj.2e40b89b.jpg";